import util from '../util/util';
import trace from '../trace/trace';
import detect from '../detect/detect';
import facebook from './facebook';
import twitter from './twitter';
import kakaostory from './kakaostory';
import kakaotalk from './kakaotalk';
import googleplus from './googleplus';
import line from './line';

let pageTitle = util.removespace(document.title).split(':plaync')[0];
let gameName = detect.gamename();

$(document).on('click.promo.share', '[data-share]', function(e){
    e.preventDefault();

    let shareType = util.trim($(this).attr('data-share'));
    let shareUrl = $(this).attr('data-share-url');

    switch(shareType) {
        case 'facebook':
            facebook(shareUrl);
            break;
        case 'twitter':
            twitter(shareUrl);
            break;

        case 'kakaostory':
            kakaostory(shareUrl);
            break;

        case 'kakaotalk':
            kakaotalk(shareUrl);
            break;

        case 'googleplus':
            googleplus(shareUrl);
            break;

        case 'line':
            line(shareUrl);
            break;
    }

    trace(`/${gameName.ko}/이벤트프로모션/${pageTitle}/${shareType}`);
});

export default {
    facebook,
    twitter,
    kakaostory,
    kakaotalk,
    googleplus,
    line
};